import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

import { camelToSnake } from '@/utils/index';

const URL_FIREWEB = process.env.VUE_APP_URL_DG_FIREWEB;

const baseHttpClient = axios.create({
  baseURL: URL_FIREWEB,
  headers: {
    'Content-Type': 'application/json',
  },
});

function customErrorHandler(error: any) {
  if (!error.response) {
    console.error('Network error', error);
    return error;
  }

  switch (error.response.status) {
    case 401: {
      const path = window.location.pathname;
      const query = window.location.search;
      const { VUE_APP_DIGI_USERS_F } = process.env;
      window.location.href = `${VUE_APP_DIGI_USERS_F}/auth/provider?app=fireweb&redirect=${path}${query}`;
      break;
    }
    case 403:
      console.error('Forbidden');
      break;
    case 404:
      console.error('Not found');
      break;
    case 500:
      console.error('Internal server error');
      break;
    default:
      console.error('Unknown error', error);
  }

  console.log('error.response.data?.code', error.response.data?.code);

  switch (error.response.data?.code) {
    case 'SUBS-VAL-004': {
      console.warn('No active subscription found', error.response.data);
      const token = localStorage.getItem('token');
      const { VUE_APP_DG_SUBS } = process.env;
      const url = `${VUE_APP_DG_SUBS}/auth/confirmsession?token=${token}&redirect=/app/services/fireweb`;
      console.warn(`Redirecting to subscription page: ${url}`);
      window.location.href = url;
      break;
    }
    case 'SUBS-VAL-005': {
      console.warn('subscription expired', error.response.data);
      const token = localStorage.getItem('token');
      const { VUE_APP_DG_SUBS } = process.env;
      const url = `${VUE_APP_DG_SUBS}/auth/confirmsession?token=${token}&redirect=/app/services/fireweb`;
      console.warn(`Redirecting to subscription page: ${url}`);
      window.location.href = url;
      break;
    }
    default:
      console.error('Error code:', error.response.data?.code);
  }

  return error;
}

baseHttpClient.interceptors.request.use((config) => {
  const modifiedConfig = config;

  const token = localStorage.getItem('token');
  if (token) {
    modifiedConfig.headers.Authorization = `DGTK ${token}`;
  }

  return modifiedConfig;
});

baseHttpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    customErrorHandler(error);
    return Promise.reject(error);
  },
);

export const httpClient = Object.assign(baseHttpClient);
